module.exports = __webpack_public_path__ + "static/img/exit-2.76f0dee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/exit-2.jpg
// module id = AsdD
// module chunks = 1